import { AlertCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '~/components/ui/button';

/** Inline error with retry for a section that failed to load (503 / network);
 *  `isRetrying` spins the button while the refetch is in flight. */
export function SectionError({
  onRetry,
  isRetrying = false,
  testId = 'workflow-inspector-section-error',
}: {
  onRetry: () => void;
  isRetrying?: boolean;
  /** Root test id (retry button gets `{testId}-retry-button`); defaults to the generic section error. */
  testId?: string;
}) {
  const { t } = useTranslation('workflow-inspection');
  return (
    <div
      className="flex flex-wrap items-center gap-3 rounded-lg border p-4 text-sm"
      data-testid={testId}
    >
      <AlertCircle aria-hidden="true" className="text-destructive size-4 shrink-0" />
      <span className="text-foreground">{t('errors.unavailable')}</span>
      <Button
        type="button"
        variant="outline"
        size="sm"
        className="cursor-pointer"
        isLoading={isRetrying}
        onClick={onRetry}
        data-testid={`${testId}-retry-button`}
      >
        {t('history.retry')}
      </Button>
    </div>
  );
}
